
<ng-container
    *ngIf="(currentRegionData?.einreisenmit && !currentRegionData?.einreisenmitisAutovonLand) else einreisenmitvonland">
    <h2>Einreise in das Urlaubsland </h2>
    <span>{{currentRegionData?.einreisenmit?.value}}</span>
</ng-container>

<ng-template #einreisenmitvonland>
    <ng-container *ngIf="
        currentRegionData.onentry?.show_covid_19_test ||
        currentRegionData.quarantine_on_entry ||
        currentRegionData.onentry?.registration
    ">
        <h2>Einreise in das Urlaubsland </h2>
        <div style="display: flex;flex-direction: column;">
            <ng-container *ngIf="currentRegionData.onentry?.show_covid_19_test">
                <ng-container *ngTemplateOutlet="COVID19Testergebniserforderlich"></ng-container>
            </ng-container>
            <ng-container *ngIf="currentRegionData.onentry?.registration">
                <ng-container *ngTemplateOutlet="Einreiseformularerforderlich"></ng-container>
            </ng-container>
            <ng-container *ngIf="currentRegionData.quarantine_on_entry">
                <ng-container *ngTemplateOutlet="QuaranteanebeiderEinreise"></ng-container>
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<ng-template #Einreiseformularerforderlich>
    <span>
        Einreiseformular erforderlich
        <ng-container *ngIf="currentRegionData?.onentry.registration_info?.length > 0">
            <mat-icon class="helpi"
                (click)="currentRegionData.onentry.registration_open_1 = !currentRegionData?.onentry.registration_open_1"
                cdkOverlayOrigin #trigger="cdkOverlayOrigin">help
            </mat-icon>
            <ng-template cdkConnectedOverlay
                (overlayOutsideClick)="currentRegionData.onentry.registration_open_1 = !currentRegionData?.onentry.registration_open_1"
                [cdkConnectedOverlayOrigin]="trigger" cdkConnectedOverlayWidth="280px"
                cdkConnectedOverlayMinWidth="100px" cdkConnectedOverlayFlexibleDimensions="true"
                [cdkConnectedOverlayOpen]="currentRegionData?.onentry.registration_open_1">
                <div class="customtooltip mat-elevation-z1">
                    <ng-container *ngFor="let con of currentRegionData?.onentry.registration_info">
                        <div [innerHTML]="con.content | linkify:false | safehtml">
                        </div>
                        <br>
                    </ng-container>
                </div>
            </ng-template>
        </ng-container>
    </span>
</ng-template>

<ng-template #COVID19Testergebniserforderlich>
    <span>
        COVID-19-Testergebnis erforderlich
        <ng-container *ngIf="currentRegionData?.onentry.show_covid_19_test_info?.length > 0">
            <mat-icon class="helpi"
                (click)="currentRegionData.onentry.show_covid_19_test_info_open_1 = !currentRegionData?.onentry.show_covid_19_test_info_open_1"
                cdkOverlayOrigin #trigger="cdkOverlayOrigin">help
            </mat-icon>
            <ng-template cdkConnectedOverlay
                (overlayOutsideClick)="currentRegionData.onentry.show_covid_19_test_info_open_1 = !currentRegionData?.onentry.show_covid_19_test_info_open_1"
                [cdkConnectedOverlayOrigin]="trigger" cdkConnectedOverlayWidth="280px"
                cdkConnectedOverlayMinWidth="100px" cdkConnectedOverlayFlexibleDimensions="true"
                [cdkConnectedOverlayOpen]="currentRegionData?.onentry.show_covid_19_test_info_open_1">
                <div class="customtooltip mat-elevation-z1">
                    <ng-container *ngFor="let con of currentRegionData?.onentry.show_covid_19_test_info">
                        <div [innerHTML]="con.content | linkify:false | safehtml">
                        </div>
                        <br>
                    </ng-container>
                </div>
            </ng-template>
        </ng-container>
    </span>
</ng-template>

<ng-template #QuaranteanebeiderEinreise>
    <span>
        Quarantäne bei der Einreise
        <ng-container *ngIf="currentRegionData?.quarinfo?.length > 0">
            <mat-icon class="helpi" (click)="currentRegionData.quarinfoopen = !currentRegionData?.quarinfoopen"
                cdkOverlayOrigin #trigger1="cdkOverlayOrigin">help
            </mat-icon>
            <ng-template cdkConnectedOverlay
                (overlayOutsideClick)="currentRegionData.quarinfoopen = !currentRegionData?.quarinfoopen"
                [cdkConnectedOverlayOrigin]="trigger1" cdkConnectedOverlayWidth="280px"
                cdkConnectedOverlayMinWidth="100px" cdkConnectedOverlayFlexibleDimensions="true"
                [cdkConnectedOverlayOpen]="currentRegionData?.quarinfoopen">
                <div class="mat-elevation-z1 customtooltip">
                    <ng-container *ngFor="let con of currentRegionData?.quarinfo">
                        <div [innerHTML]="con.content | linkify:false | safehtml">
                        </div>
                        <br>
                    </ng-container>
                </div>
            </ng-template>
        </ng-container>
    </span>
</ng-template>